import React from 'react';

export const PdfViewer = function ({url}) {
  return <embed src={url} type="application/pdf" frameBorder="0" scrolling="auto" width="100%"></embed>;
};
